export enum OfflineExportsCrmExportTypesEnum {
    SALESFORCE = 'SALESFORCE',
    HUBSPOT = 'HUBSPOT',
}
